export class RepeatedEvery {
  private _numDuration: number;
  private _strInterval: string;

  get duration(): number {
    return this._numDuration;
  }

  get rawInterval(): string {
    return this._strInterval;
  }

  get interval(): string {
    if (this._strInterval === 'mon') {
      return 'month';
    }

    if (this._strInterval === 'mons') {
      return 'months';
    }

    return this._strInterval;
  }

  get passToApiFormat(): string {
    let numDuration = this._numDuration;
    let strIntervalText = this._strInterval;

    if (strIntervalText === 'day') {
      if (numDuration !== 1) {
        strIntervalText = 'days';
      }
    }

    if (strIntervalText === 'week') {
      numDuration = numDuration * 7;
      strIntervalText = 'days';
    }

    if (strIntervalText === 'month') {
      if (numDuration === 1) {
        strIntervalText = 'mon';
      } else {
        strIntervalText = 'mons';
      }
    }

    if (strIntervalText === 'year') {
      if (numDuration !== 1) {
        strIntervalText = 'years';
      }
    }

    return `${numDuration} ${strIntervalText}`;
  }

  constructor(numDuration: number, strInterval: string) {
    this._numDuration = numDuration;
    this._strInterval = strInterval;
  }
}